var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"xs-12 flex xs-center wrap p4 md-pt2 md-p8 pb10"},[_c('div',{class:[
			{ small: _vm.props.small },
			{ medium: _vm.props.medium },
			{ large: _vm.props.large },
			{ full: _vm.props.full }
		]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }